import 'normalize.css/normalize.css'
import 'element-ui/lib/theme-chalk/index.css'
import VueQriously from 'vue-qriously';

import Vue from 'vue'
import Element from 'element-ui'
import '@savoygu/vue-material-design-icons/src/icons'
import Icon from '@savoygu/vue-material-design-icons/src/components/Icon'

import config from '../config'
import axios from './axios'
import formHelper from './form-helper'
import tableHelper from './table-helper'
import enums from './enums'

Vue.use(Element, {
  size: 'medium'
})

Vue.use({
  install(vue) {
    vue.prototype.$config = config
  }
})

Vue.use(axios, config)
Vue.use(formHelper)
Vue.use(tableHelper)
Vue.use(enums)
Vue.use(VueQriously)

Vue.component('icon', Icon)
